'use strict';

module.exports = {
    template: '#error'
};
